import React from 'react';
import { Layout, Row, Col, Button, Typography, Space, Drawer, Menu } from 'antd';
import {
  UserOutlined,
  ProfileOutlined,
  EditOutlined,
  LockOutlined,
  KeyOutlined,
  SettingOutlined,
  WalletOutlined,
  ArrowDownOutlined,
  LoginOutlined,
  UserAddOutlined,
  MenuOutlined,
  HomeOutlined,
  MoneyCollectOutlined,
  SolutionOutlined,
  SwapOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { checkMobile } from '../../comonFunction/utils';

const { Header } = Layout;
const { Text } = Typography;

const isMobile = checkMobile() === 1;

class HeaderSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarVisible: false,
      isMobile: isMobile,
      isVerySmallScreen: window.innerWidth < 350,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({
      isMobile: checkMobile() === 1,
      isVerySmallScreen: window.innerWidth < 350,
    });
  };

  toggleSidebar = () => {
    this.setState((prevState) => ({ sidebarVisible: !prevState.sidebarVisible }));
  };

  render() {
    const { logedIn, userInfo, logout } = this.props;
    const { sidebarVisible, isMobile, isVerySmallScreen } = this.state;

    return (
      <>
        <Header
          style={{
            minHeight: '6vh',
            background: '#0C3224',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            padding: '0 24px',
            minWidth: isVerySmallScreen ? '306px' : 'auto',
          }}
        >
          <Row align="middle" justify="space-between">
            <Col>
              <Button
                type="text"
                icon={<MenuOutlined style={{ color: '#fff', fontSize: '18px' }} />}
                onClick={this.toggleSidebar}
                style={{ background: 'transparent', border: 'none' }}
              />
            </Col>

            <Col>
              <Link to="/">
                <div
                  style={{
                    fontSize: isMobile ? '18px' : '24px',
                    fontWeight: 'bold',
                    color: '#C8CDCE',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <span
                    style={{
                      fontSize: isMobile ? '14px' : '17px',
                      fontWeight: 'bold',
                      letterSpacing: '2px',
                    }}
                  >
                  OPEN65
                  </span>
                </div>
              </Link>
            </Col>

            <Col>
              <Space size="middle">
                {!logedIn ? (
                  <>
                    <Link to="/join">
                      <Button
                        type="primary"
                        icon={!isVerySmallScreen && <UserAddOutlined />}
                        style={{
                          background: 'linear-gradient(to right,rgb(68, 181, 145),rgb(9, 96, 69))',
                          border: 'none',
                          borderRadius: '5px',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        }}
                      >
                        {isVerySmallScreen ? 'Join' : 'Register'}
                      </Button>
                    </Link>

                    <Link to="/login">
                      <Button
                        type="primary"
                        icon={!isVerySmallScreen && <LoginOutlined />}
                        style={{
                          background: 'linear-gradient(to right,rgb(58, 219, 168), #14805E)',
                          border: 'none',
                          borderRadius: '5px',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        }}
                      >
                        Login
                      </Button>
                    </Link>
                  </>
                ) : (
                  <>
                    {/* Always show the balance for all devices */}
                    <Space>
                      <Text strong style={{ color: '#fff', fontSize: isMobile ? '14px' : '16px' }}>
                        {userInfo?.balance.toFixed(1)} ৳
                      </Text>
                    </Space>

                    <Link to="/deposit">
                      <Button
                        type="primary"
                        icon={<WalletOutlined />}
                        style={{
                          background: 'linear-gradient(to right,rgb(125, 129, 124),rgb(142, 107, 156))',
                          border: 'none',
                          borderRadius: '5px',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                          padding: isMobile ? '4px 8px' : 'auto',
                          fontSize: isMobile ? '12px' : '14px',
                        }}
                      >
                        Deposit
                      </Button>
                    </Link>
                  </>
                )}
              </Space>
            </Col>
          </Row>
        </Header>

        <Drawer
          placement="left"
          closable={true}
          onClose={this.toggleSidebar}
          visible={sidebarVisible}
          width={250}
          bodyStyle={{ padding: '0' }}
          drawerStyle={{ transition: 'all 0.3s ease-in-out' }}
        >
          <Menu mode="inline" style={{ borderRight: 'none' }} onClick={this.toggleSidebar}>
            {logedIn ? (
              <>
                <Menu.Item key="1">
                  <HomeOutlined />
                  <Link to="/">Home</Link>
                </Menu.Item>

                <Menu.SubMenu key="finance" title="Finance" icon={<MoneyCollectOutlined />}>
                  <Menu.Item key="Deposit History">
                    <WalletOutlined />
                    <Link to="/deposit">Deposit</Link>
                  </Menu.Item>
                  <Menu.Item key="Withdraw History">
                    <ArrowDownOutlined />
                    <Link to="/withdraw">Withdraw</Link>
                  </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu key="Statement" title="Statement" icon={<ProfileOutlined />}>
                  <Menu.Item key="work-history" icon={<SolutionOutlined />}>
                    <Link to="/work history">Bet History</Link>
                  </Menu.Item>
                  <Menu.Item key="deposit-history" icon={<WalletOutlined />}>
                    <Link to="/deposit history">Deposit History</Link>
                  </Menu.Item>
                  <Menu.Item key="withdraw-history" icon={<ArrowDownOutlined />}>
                    <Link to="/withdraw history">Withdraw History</Link>
                  </Menu.Item>
                  <Menu.Item key="transaction history" icon={<SwapOutlined />}>
                    <Link to="/transection history">Transaction History</Link>
                  </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu key="Account" title="Account" icon={<ProfileOutlined />}>
                  <Menu.Item key="account-info" icon={<UserOutlined />}>
                    <Link to="/account info">Account Info</Link>
                  </Menu.Item>
                  <Menu.Item key="account-update" icon={<EditOutlined />}>
                    <Link to="/account update">Account Update</Link>
                  </Menu.Item>
                  <Menu.Item key="password-update" icon={<LockOutlined />}>
                    <Link to="/password update">Password Update</Link>
                  </Menu.Item>
                  <Menu.Item key="club-update" icon={<LockOutlined />}>
                    <Link to="/club update">Club Update</Link>
                  </Menu.Item>
                  <Menu.Item key="six-digit-pin" icon={<KeyOutlined />}>
                    <Link to="/six digit pin">6 Digit Pin</Link>
                  </Menu.Item>
                </Menu.SubMenu>

                <Menu.Item key="settings" icon={<SettingOutlined />}>
                  <Link to="/settings option">Settings</Link>
                </Menu.Item>
                <Menu.Item
                  key="logout"
                  icon={<LogoutOutlined />}
                  style={{ color: 'red', fontWeight: 'bold' }}
                  onClick={logout}
                >
                  Logout
                </Menu.Item>
              </>
            ) : (
              <Menu.Item key="login">
                <LoginOutlined />
                <Link to="/login">LogIn</Link>
              </Menu.Item>
            )}
          </Menu>
        </Drawer>
      </>
    );
  }
}

export default HeaderSection;
